module.exports = __webpack_public_path__ + "img/thinking.a75b5b59.svg";